import SocialLinkWithIcon from '@components/shared/SocialLinkWithIcon';
import { GoalLandingPageMentorModel } from '@models/goals';
import { setupForDark } from '@theme';
import classNames from 'classnames';
import { parseHighlightedText } from './highlighters';

interface MentorBioCardProps {
  mentor: GoalLandingPageMentorModel;
  accentColor: string;
}

export default function MentorBioCard({ mentor, accentColor }: MentorBioCardProps) {
  return (
    <div
      className={classNames(
        'flex flex-col @[768px]:flex-row gap-huge items-center @[768px]:items-start rounded-lg w-full'
      )}
    >
      <div
        className={classNames(
          'border-2 rounded-lg shrink-0 relative overflow-hidden',
          'w-[280px] h-[280px] @[1280px]:w-[360px] @[1280px]:h-[360px]'
        )}
        style={{ borderColor: accentColor }}
      >
        <img
          alt={mentor.name}
          className='absolute h-full max-w-none top-0'
          src={mentor?.avatarUrl}
        />
      </div>

      <div className='flex-1 flex flex-col gap-xl items-center @[768px]:items-start min-w-0'>
        <div className='flex flex-col gap-xxs items-center @[768px]:items-start w-full'>
          <div
            className={classNames(
              'flex flex-col font-semibold leading-[1.2]',
              'text-[28px] @[480px]:text-[32px] @[640px]:text-[40px] break-words'
            )}
            style={{ color: accentColor }}
          >
            <p className='whitespace-pre-wrap text-center @[768px]:text-left'>{mentor.name}</p>
          </div>
          <div
            className={classNames(
              'flex flex-col font-normal leading-[1.2]',
              setupForDark('text-white'),
              'text-[24px] @[640px]:text-[36px] break-words'
            )}
          >
            <p className='whitespace-pre-wrap text-center @[768px]:text-left'>
              {parseHighlightedText(mentor.title, 'text-white', undefined, accentColor)}
            </p>
          </div>
        </div>

        <div className='flex flex-col items-start justify-center w-full'>
          <div
            className={classNames(
              'flex flex-col font-normal leading-[1.6] w-full',
              setupForDark('text-white'),
              'text-center @[768px]:text-left text-[16px] @[640px]:text-[20px]'
            )}
          >
            {parseHighlightedText(mentor.bio, 'text-white', undefined, accentColor)}
          </div>
        </div>

        <div className='flex flex-wrap gap-md items-center w-full justify-center @[768px]:justify-start'>
          {(mentor.socialLinks ?? [])
            .filter((link) => link.url?.trim())
            .map((link, index) => (
              <SocialLinkWithIcon
                key={`${link.type}-${index}`}
                type={link.type}
                url={link.url}
                color={accentColor}
              />
            ))}
        </div>
      </div>
    </div>
  );
}
